// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lTO7N","label":"styles_label__2A4sM"};